import React from 'react';

import AiDataTransferContent from 'sections/aiDataTransfer/AiDataTransferContent';
import AiDataTransferTop from 'sections/aiDataTransfer/AiDataTransferTop';
import { SEO } from 'hooks/useSeo';
import { PageUrl } from 'const/page-url';

const AiDataTransfer: React.FC = () => {
    return (
        <React.Fragment>
            <SEO
                title="外部AI事業者への個人情報の送信に関する説明書 | OHANA AI"
                description="OHANA AI のAI機能で外部AI事業者へ送信される情報、送信先の事業者と所在国、米国への移転についての当社の対応、事業所での公表事項の記載文例を掲載しています。"
                path={PageUrl.AiDataTransfer.urlWithSlash}
            />
            <AiDataTransferTop />
            <AiDataTransferContent />
        </React.Fragment>
    );
};

export default AiDataTransfer;
